module.exports = __webpack_public_path__ + "assets/img/season-code-02-bf424357.png";